import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";
import { forEachRoomNoBlockLayout } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_45: DocMigration = {
  maxSchemaVersion: "0.0.45",
  description: "Convert annotation to a uid object, migrate deprecated polyline2s to linework",
  apply(json: any) {
    forEachRoomNoBlockLayout(json, (room) => {
      const { layout } = room;
      if (!layout?.annotation) {
        return;
      }

      const annotationDstObject = {};

      for (const annotation of layout.annotation) {
        switch (annotation.type) {
          case "PLAN_POLYLINE2": {
            const { dashed, polyLine, ...rest } = annotation;

            if (!polyLine) {
              continue;
            }

            const referenceGeom = json.referenceGeom[polyLine.geomId];
            if (!referenceGeom) {
              continue;
            }

            annotationDstObject[uid()] = {
              // copy visibility properties
              ...rest,
              type: "LINEWORK",
              shapes: {
                [uid()]: {
                  dashed: annotation.dashed,
                  path: referenceGeom.geom,
                },
              },
            };

            break;
          }
          default: {
            annotationDstObject[uid()] = annotation;
          }
        }
      }

      layout.annotation = annotationDstObject;
    });

    return json;
  },
};

export default migration_0_0_45;
